<template>
  <InputVue
    :name="name"
    :label="label"
    :cssClasses="cssWrapperClasses"
    :labelAsPlaceholder="labelAsPlaceholder"
    :hasError="hasError">
    <template #input-slot>
      <input 
        class="form-control password" 
        autocomplete="off"
        :name="name" 
        :type="type"
        :value="modelValue"
        @input="updateValue"
        :placeholder="labelAsPlaceholder ? placeholder : '' " />
      <span class="material-symbols-outlined" @click="toggleVisibility">{{ icon }}</span>
    </template>
  </InputVue>
</template>

<script>
import InputVue from './InputCompVue'

export default {
  name: 'PasswordInputVue',

  props: {
    modelValue: String,
    name: String,
    label: String,
    focus: Boolean,
    cssClasses: String,
    labelAsPlaceholder: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
  },

  data() {
    return {
      hasError: false,
      errors: { hasError: 'error' },
      visible: false,
      type: 'password',
      icon: 'visibility_off',
    }
  },

  computed: {
    cssWrapperClasses() {
      return `${this.cssClasses} password-input-wrapper`
    },
  },

  methods: {
    updateValue(e) {
      this.$emit('update:modelValue', e.target.value)
    },

    toggleVisibility() {
      this.visible = !this.visible
      if (this.visible) {
        this.type = 'text'
        this.icon = 'visibility'
      } else {
        this.type = 'password'
        this.icon = 'visibility_off'
      }
    },

    toggleError() {
      this.hasError = !this.hasError
    },
  },

  created() {
  },

  components: {
    InputVue,
  },
}
</script>

<style lang="scss" scoped>
.form-control.password {
}

.material-symbols-outlined {
  position: absolute;
  right: 5px;
  top: 8px;
  font-size: $font;
  cursor: pointer;
}
</style>
